/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Billing_Addon_RunnerInputs */

const en_billing_addon_runner = /** @type {(inputs: Billing_Addon_RunnerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} Runner steps`)
};

const id_billing_addon_runner = /** @type {(inputs: Billing_Addon_RunnerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.n} langkah Bangunkan`)
};

/**
* | output |
* | --- |
* | "+{n} Runner steps" |
*
* @param {Billing_Addon_RunnerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addon_runner = /** @type {((inputs: Billing_Addon_RunnerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addon_RunnerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addon_runner(inputs)
	return en_billing_addon_runner(inputs)
});